import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { URLS } from '../../../data/navigation/navigation.data';
import { AnalyticsService } from '../../../service/analytics/analytics.service';
import { StoreService } from '../../../service/store/store.service';

/**
 * /order/find - "lost your download link?": the visitor enters the e-mail they
 * paid with, the server mails the order links of every paid order under it.
 * The answer is the same whether or not orders exist (no address probing), so
 * the page always shows the same "check your inbox" note. See
 * base-themes/STORE-DESIGN.md §3.5.
 */
@Component( {
  selector: 'app-order-find-page',
  templateUrl: './order-find-page.component.html',
  styleUrls: [ './order-find-page.component.scss' ],
} )
export class OrderFindPageComponent {

  URLS = URLS;

  form = new FormGroup( {
    email: new FormControl( '', [ Validators.required, Validators.email, Validators.maxLength( 254 ) ] ),
  } );

  submitted = false;
  sending = false;
  sent = false;
  sentTo = '';
  errorMessage: string | null = null;

  constructor( private storeService: StoreService, private analyticsService: AnalyticsService ) {
  }

  onSubmit( event?: Event ): void {
    event?.preventDefault();
    this.submitted = true;
    this.errorMessage = null;
    if ( this.form.invalid || this.sending ) return;

    const email = ( this.form.controls.email.value || '' ).trim();
    this.sending = true;
    this.analyticsService.logEvent( 'Find Order Requested', {} );

    this.storeService.findOrder( email ).subscribe( {
      next: () => {
        this.sending = false;
        this.sent = true;
        this.sentTo = email;
      },
      error: ( err ) => {
        this.sending = false;
        this.errorMessage = err?.status === 429
          ? 'Too many requests. Please wait a minute and try again.'
          : ( err?.error?.message || 'We could not send the e-mail right now. Please try again in a minute.' );
      },
    } );
  }

  reset(): void {
    this.sent = false;
    this.submitted = false;
    this.form.reset( { email: '' } );
  }
}
